/* eslint-disable react/prop-types */
/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Link from '@zg-rentals/multibrand-ui/lib/Link';
import CheckCircleFill from '@zg-rentals/multibrand-ui/lib/icons/CheckCircleFill';
import StyledContainer from '@zg-rentals/multibrand-ui/lib/StyledContainer';
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import './style.scss';

const photoUnavailablePaths = {
  hotpads: 'https://s3.amazonaws.com/files.hotpads.com/images/errors/missing-photo-180x180-hotpads.png',
  zillow: 'https://s3.amazonaws.com/files.hotpads.com/images/errors/missing-photo-180x180-zillow.png',
  trulia: 'https://s3.amazonaws.com/files.hotpads.com/images/errors/missing-photo-180x180-trulia.png',
};

class SurveyListingCard extends React.Component {
  static propTypes = {
    feedbackTypes: PropTypes.object,
    listing: PropTypes.object,
    onSubmitFeedback: PropTypes.func,
  };
  static defaultProps = {
    feedbackTypes: {},
    listing: {},
    onSubmitFeedback: () => {},
  };

  constructor(props) {
    super(props);

    this.submitFeedback = this.submitFeedback.bind(this);
    this.handleYesClick = this.handleYesClick.bind(this);
    this.handleNoClick = this.handleNoClick.bind(this);
  }

  submitFeedback(type) {
    const { listing, onSubmitFeedback, feedbackTypes } = this.props;
    onSubmitFeedback(feedbackTypes[type], listing.inquiryId, listing.hash);
  }

  handleYesClick() {
    this.submitFeedback('YES');
  }

  handleNoClick() {
    this.submitFeedback('NO');
  }

  render() {
    const { listing, brand, yesButtonText, yesButtonActive, noButtonActive } = this.props;
    const { title, pricing, beds, photoUrl, uri } = listing;

    const photoPath = photoUrl ? photoUrl : photoUnavailablePaths[brand];

    return (
      <StyledContainer borderFull borderRounded className="SurveyListingCard">
        <div className="SurveyListingCard-listing">
          <div className="SurveyListingCard-listing-image-wrapper">
            <Link to={uri}>
              <img src={photoPath} className="SurveyListingCard-listing-image" />
            </Link>
          </div>
          <div className="SurveyListingCard-text">
            <Text
              type="h4"
              emphasize
              className="SurveyListingCard-title"
              onClick={() => {
                window.router.transitionTo(uri, true);
              }}
            >
              {title}
            </Text>
            <Text className="SurveyListingCard-price-bed" type="body" lowlight>
              {pricing} • {beds}
            </Text>
            <div className="SurveyListingCard-buttons">
              <Button
                type={yesButtonActive ? 'primary' : 'tertiary'}
                className="SurveyListingCard-button"
                full
                onClick={this.handleYesClick}
              >
                {yesButtonText}
              </Button>
              <Button
                type={noButtonActive ? 'primary' : 'tertiary'}
                className="SurveyListingCard-button"
                full
                onClick={this.handleNoClick}
              >
                No
              </Button>
            </div>
          </div>
          {(yesButtonActive || noButtonActive) && (
            <CheckCircleFill className="SurveyListingCard-check-icon" size="16" />
          )}
        </div>
      </StyledContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  brand: state.app.brand,
});

export default connect(mapStateToProps)(SurveyListingCard);
